/* eslint-disable react/no-unused-class-component-methods */
import React from 'react';
import { Pane, Button, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './OkayCancelView.css';

// const PLACEMENT = {
//   position : 'absolute',
//   bottom : 'var( --size-padXLarge, 24px)',
//   left : 'var( --size-padXLarge, 24px)',
//   // left : '50%',
//   // transform : 'translate( -50%, 0)',
//   // textAlign : 'center',
//   padding : 'var( --size-padSmall, 8px)'
// }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.imagine.map.OkayCancelView');
export default class OkayCancelView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      okayDisabled: true,
      help: props.help,
      title: props.title
    };
  }
  setOkayDisabled(disabled) {
    this.setState({
      okayDisabled: disabled
    });
  }
  setHelp(title, help) {
    this.setState({
      title,
      help
    });
  }
  render() {
    const {
      paneVariant = 'dialog',
      helpVariant = 'caption',
      okay = t('okay'),
      titleVariant = 'cardTitle',
      icon = tIcon('icon', 'https://molten-ui-assets.storage.googleapis.com/light-bulb.png'),
      cancel = t('cancel'),
      okayVariant = 'primary',
      cancelVariant = 'secondary',
      onCreate,
      onCancel
    } = this.props;
    const {
      title,
      help,
      okayDisabled
    } = this.state;
    return /*#__PURE__*/_jsxs(Pane, {
      className: S.pane,
      variant: paneVariant,
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.title,
        variant: titleVariant,
        children: title
      }), /*#__PURE__*/_jsx(Text, {
        className: S.help,
        variant: helpVariant,
        icon: icon,
        children: help
      }), /*#__PURE__*/_jsx(Button, {
        className: S.cancel,
        variant: cancelVariant,
        onClick: onCancel,
        children: cancel
      }), /*#__PURE__*/_jsx(Button, {
        className: S.okay,
        disabled: okayDisabled,
        variant: okayVariant,
        onClick: onCreate,
        children: okay
      })]
    });
  }
}